import {
    ADDON_SERVICES_ERROR_ACTION_TYPE,
    ADDON_SERVICES_FETCH_ACTION_TYPE,
    ADDON_SERVICES_FETCH_SUCCESS_ACTION_TYPE,
    AddonServicesAction
} from 'actions/addonServices/AddonServicesActionsTypes';
import { convertToAddonService } from 'actions/addonServices/AddonServicesConverter';
import { AddonServiceDto } from 'actions/addonServices/AddonServicesDtos';
import { ApiPublicClient } from 'api/ApiClient';
import { AxiosResponse } from 'axios';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { AddonService } from 'types/AddonService';

const resourceUrl = 'addon_service_lookup';

const errorHandler = (error: unknown): AddonServicesAction => {
    console.error(error);

    return {
        type: ADDON_SERVICES_ERROR_ACTION_TYPE
    };
};

export const fetchAddonServicesThunk = (
    marketplaceId: number
): ThunkAction<Promise<Array<AddonService>>, RootState, null, RootAction> => {
    return async dispatch => {
        dispatch({
            type: ADDON_SERVICES_FETCH_ACTION_TYPE
        });

        try {
            const response: AxiosResponse<Array<AddonServiceDto>> = await ApiPublicClient.get(
                resourceUrl,
                {
                    params: {
                        marketplace_id: marketplaceId
                    }
                }
            );

            const addonServices = response.data.map(service => convertToAddonService(service));

            dispatch({
                type: ADDON_SERVICES_FETCH_SUCCESS_ACTION_TYPE,
                payload: {
                    addonServices
                }
            });

            return addonServices;
        } catch (error) {
            dispatch(errorHandler(error));

            throw error;
        }
    };
};
